import React from 'react'
import { DashboardChartPaper, LineChart } from 'components'
import { isEmpty } from 'lodash'

import theme from 'theme'
import phishingConstants from 'constants/phishing'

const { MONTH_LABELS } = phishingConstants

const formatPeriod = (period) => {
  const [year, month] = period.split('-')
  return `${MONTH_LABELS[parseInt(month, 10) - 1]}/${year.slice(2)}`
}

const PhishingDashboardChart = ({ indicators }) => {
  const { phishing: phishingColors } = theme.palette.dashboard.chart

  const timeline = indicators?.timeline ?? []

  const categories = isEmpty(timeline)
    ? []
    : timeline.map((item) => formatPeriod(item.period))

  const series = [
    { name: 'Entregues', data: timeline.map((item) => item.delivered) },
    { name: 'Cliques', data: timeline.map((item) => item.clicked) },
    { name: 'Comprometidos', data: timeline.map((item) => item.compromised) },
  ]

  const chartColors = [
    phishingColors.delivered,
    phishingColors.clicks,
    phishingColors.compromised,
  ]

  return (
    <DashboardChartPaper
      title="Evolução das campanhas"
      subtitle="Entregues, cliques e comprometidos por período"
    >
      <LineChart
        id="phishing-dashboard-evolution-chart"
        categories={categories}
        series={series}
        height={250}
        colors={chartColors}
      />
    </DashboardChartPaper>
  )
}

export default PhishingDashboardChart
